<template>
  <div
    class="flex items-center"
    :class="[isTransparent && 'is-gift-card']"
    :style="holderStyles"
  >
    <label :class="{ disabled: disabled }" :style="labelStyles">
      <input
        :name="name"
        :id="value"
        :type="type"
        ref="radio"
        :value="value"
        :checked="isChecked"
        @change="changed"
        :disabled="disabled"
        v-bind="$attrs"
      />
      <span
        :class="{ disabled: disabled, isTransparent: isTransparent }"
      ></span>
    </label>

    <div class="flex items-center">
      <label
        :for="value"
        class="label inter"
        :class="{ disabled: disabled, padded: isGroupOrder }"
        :style="customStyles"
      >
        {{ label }}
      </label>
      <p class="extra-text inter" v-if="extraText">{{ extraText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gem-radio',
  inheritAttrs: false,

  model: {
    prop: 'modelValue',
    event: 'change'
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'radio'
    },

    modelValue: {
      default: ''
    },

    value: {
      type: [String, Boolean],
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: '',
      required: false
    },

    customStyles: {
      type: String,
      default: ''
    },

    labelStyles: {
      type: String,
      default: ''
    },
    holderStyles: {
      type: String,
      default: ''
    },

    extraText: {
      type: String,
      default: ''
    },

    isGroupOrder: {
      type: Boolean,
      default: false
    },

    isTransparent: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({ mounted: false }),

  mounted: function() {
    this.mounted = true
  },

  computed: {
    isChecked: function() {
      if (this.mounted) return this.modelValue == this.$refs.radio.value
      else return false
    },
    computedValue: function() {
      return !this.value ? this.label : this.value
    }
  },

  methods: {
    changed: function() {
      this.$emit('change', this.$refs.radio.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
label {
  position: relative;
  cursor: pointer;
  margin-top: 1px;
}

span {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 2px solid #25282a;
  display: inline-block;
  background: white;
  transition: all linear 0.3s;

  &.isTransparent {
    background: transparent;
    border: 1px solid #25282a;
  }
}
span.disabled {
  border: 2px solid #9b9b9b;
}
span:after {
  content: '';
  position: absolute;
  top: 5px;
  left: 5px;
  border: 1px solid #fff;
  height: 0.375rem;
  width: 0.375rem;
  background: white;
  border-radius: 50%;
  transform: rotate(45deg);
  visibility: hidden;
}
span.isTransparent:after {
  content: '';
  position: absolute;
  top: 3.5px;
  left: 3.5px;
  height: 0.575rem;
  width: 0.575rem;
  background: #232220;
  border-radius: 50%;
  transform: rotate(45deg);
  visibility: hidden;
  // border: 1px solid #232220;
}
input {
  display: none;
}
input:checked ~ span {
  background: #25282a;
  border: 2px solid #25282a;

  &.isTransparent {
    background: transparent;
    border: 1px solid #25282a;
  }
}
input:checked ~ span:after {
  visibility: visible;
}
.label {
  font-size: 0.875rem;
  color: #25282a;
  margin-left: 0.5rem;
  cursor: pointer;
}

.label.padded {
  position: relative;
  bottom: 2px;
}

.disabled {
  /* opacity: 0.6; */
  color: #9b9b9b;
  cursor: not-allowed;
}

.extra-text {
  font-size: 0.813rem;
  color: #24292c;
  font-weight: 400;
  margin-left: 1rem;
}

.is-modal-variant {
  input:checked ~ span {
    background: inherit;
    border: 1px solid #25282a;
  }

  span {
    width: 18px;
    height: 18px;

    &::after {
      top: 5px;
      left: 5px;
      height: 8px;
      width: 8px;
    }
  }
}
.is-gift-card {
  input:checked ~ span {
    background: inherit;
    border: 0.5px solid #25282a;
  }

  span {
    width: 18px;
    height: 18px;
    border: 1px solid #25282a;
    background-color: transparent;

    &::after {
      background: #25282a;
      background: #25282a;
      top: 2.5px;
      left: 2.5px;
      height: 13px;
      width: 13px;
    }
  }
}
</style>
